module.exports = __webpack_public_path__ + "img/dv.b29d7aa8.png";